
export class TrueFalse {
  T?: number;
  F?: number;
}

export class RatingValue {
  rating?: string;
  value?: number;
  label?: string;
}

export class RatingMap {
  L: number;
  M: number;
  H: number;
  showMedHigh: boolean;
  singleRating: string;
}

export interface RiskSummaryItem {
  value: number;
  label: string;
  showWarningIcon?: boolean;
  class?: string;
}

export class TopAdSize {
  size: string;
  count: number;
}

export const RATING_LABEL_MAPPING = {
  L: 'Low',
  M: 'Medium',
  H: 'High'
};

export const COLOR_MAP = {
  L: '#3CC778',
  M: '#EFAA2B',
  H: '#FA574B'
};

export const APP_MAPPING_KEYS = [
  'pixalateRating',
  'appDescriptionBrandSafetyRating',
  'adultContentRating',
  'alcoholContentRating',
  'drugContentRating',
  'hateSpeechRating',
  'offensiveContentRating',
  'gamblingContentRating',
  'violenceContentRating',
  'isIncentivizedApp',
];

export const CTV_MAPPING_KEYS = [
  'pixalateRisk',
  'brandSafetyRisk',
  'advisoriesRisk',
  'adultContentRisk',
  'drugContentRisk',
  'alcoholContentRisk',
  'hateSpeechRisk',
  'offensiveContentRisk'
];

export const APP_TRUEFALSE_KEYS = [
  'isExistInAppStore',
  'hasAdsTxt',
  'hasPrivacyLink',
  'isBlacklisted',
  'isPrivateDomain'
];

export const CTV_TRUEFALSE_KEYS = [
  'isAdsTxtEnabled'
];

export const DOMAIN_TRUEFALSE_KEYS = [
  'isVideoAvailable',
  'isAdsDotTxtExist',
];

export const DOMAIN_MAPPING_KEYS = [
  'risk',
  'brandSafetyRisk',
  'adultContentRating',
  'alcoholContentRating',
  'drugsContentRating',
  'numberOfHateSpeechWordsRating',
  'isIncentivizedApp',
];

export const APP_BRANDSAFETYRATING_KEYS = [
  { key: 'adultContentRating', label: 'Adult Content' },
  { key: 'alcoholContentRating', label: 'Alcohol Content'},
  { key: 'drugContentRating', label: 'Drug Content'},
  { key: 'hateSpeechRating', label: 'Hate Speech'},
  { key: 'offensiveContentRating', label: 'Offensive Content'},
  { key: 'gamblingContentRating', label: 'Gambling Content'},
  { key: 'violenceContentRating', label: 'Violence Content'}
];

export const DOMAIN_BRANDSAFETYRATING_KEYS = [
  { key: 'adultContentRating', label: 'Adult Content' },
  { key: 'alcoholContentRating', label: 'Alcohol Content'},
  { key: 'drugsContentRating', label: 'Drug Content'},
  { key: 'numberOfHateSpeechWordsRating', label: 'Hate Speech'}
];

export const CTV_BRANDSAFETYRATING_KEYS = [
  { key: 'advisoriesRisk', label: 'Advisories' },
  { key: 'adultContentRisk', label: 'Adult Content' },
  { key: 'drugContentRisk', label: 'Drug Content' },
  { key: 'alcoholContentRisk', label: 'Alcohol Content' },
  { key: 'hateSpeechRisk', label: 'Hate Speech' },
  { key: 'offensiveContentRisk', label: 'Offensive Content' }
];

export class ValueCount {
  value?: string;
  count?: number;
}

export class GivtSivtRate {
  average?: number;
  appsLess5percent?: number;
}


export class AppSummaryResponse {
  total?: number;
  isExistInAppStore?: TrueFalse;
  hasAdsTxt?: TrueFalse;
  hasPrivacyLink?: TrueFalse;
  isBlacklisted?: TrueFalse;
  isPrivateDomain?: TrueFalse;
  isIncentivizedApp?: any;
  pixalateRating?: RatingMap;
  appDescriptionBrandSafetyRating?: RatingMap;
  adultContentRating?: RatingMap;
  alcoholContentRating?:  RatingMap;
  drugContentRating?: RatingMap;
  hateSpeechRating?: RatingMap;
  offensiveContentRating?: RatingMap;
  gamblingContentRating?: RatingMap;
  violenceContentRating?: RatingMap;
  givtSivtRate?: GivtSivtRate;
  nonGivtSivtViewability?: number;
  topAdSizes?: Array<TopAdSize>;
  givtRate?: number;
  sivtRate?: number;


  /* DOMAINS */
  risk?: RatingMap;
  brandSafetyRisk?: RatingMap;
  isAdsDotTxtExist?: TrueFalse;
  trafficSource: any;
}

export const DEFAULT_TRUEFALSE: TrueFalse = {
  T: 0,
  F: 0
}

export const DEFAULT_RATINGMAP: RatingMap = {
  H : 0,
  M : 0,
  L: 0,
  showMedHigh: false,
  singleRating: 'low'
}

export const DEFAULT_GIVTSIVTRATE: GivtSivtRate = {
  average: 0,
  appsLess5percent: 0
}

export const DEFAULT_TOP_ADSISZSE: Array<TopAdSize> = [
  {
    size : '0x0',
    count : 0
  }
];

export const DEFAULT_MAP: any = {
  'true' : 0,
  'false' : 0
}

export const DEFAULT_APPSUMMARYRESPONSE: AppSummaryResponse = {
  total :  0,
  isExistInAppStore : DEFAULT_TRUEFALSE,
  hasAdsTxt : DEFAULT_TRUEFALSE,
  hasPrivacyLink : DEFAULT_TRUEFALSE,
  isBlacklisted : DEFAULT_TRUEFALSE,
  isPrivateDomain : DEFAULT_TRUEFALSE,
  isIncentivizedApp: DEFAULT_MAP,
  pixalateRating: DEFAULT_RATINGMAP,
  appDescriptionBrandSafetyRating: DEFAULT_RATINGMAP,
  adultContentRating : DEFAULT_RATINGMAP,
  alcoholContentRating: DEFAULT_RATINGMAP,
  drugContentRating: DEFAULT_RATINGMAP,
  hateSpeechRating: DEFAULT_RATINGMAP,
  offensiveContentRating: DEFAULT_RATINGMAP,
  gamblingContentRating: DEFAULT_RATINGMAP,
  violenceContentRating: DEFAULT_RATINGMAP,
  givtSivtRate : DEFAULT_GIVTSIVTRATE,
  nonGivtSivtViewability : 0,
  topAdSizes : DEFAULT_TOP_ADSISZSE,
  givtRate: 0,
  sivtRate: 0,
  risk : DEFAULT_RATINGMAP,
  brandSafetyRisk : DEFAULT_RATINGMAP,
  isAdsDotTxtExist : DEFAULT_TRUEFALSE,
  trafficSource : {
    'N/A' : 0
  }
}
